import { useEffect, useState } from "react";
import {
  AlertCircle,
  CalendarIcon,
  ChevronDown,
  Download,
  FileSpreadsheet,
  FileText,
  Filter,
  RefreshCw,
  Search,
  SlidersHorizontal,
} from "lucide-react";
import { getLogsByOrg, getOrgEmployees } from "../../API/Company-admin/userApi";
import { useDispatch, useSelector } from "react-redux";
import Table from "../common/table/Table";
import { getAllProject } from "../../Redux/Actions/projectActions";
import { useRef } from "react";
import { handleExport } from "../../utils/handleExport";
import DateRangeFilter from "../date-range-filter";

export default function ActivityLogs() {
  const { userInfo } = useSelector((state) => state.userLogin);
  const { allProjectData, loading, error, emptyProject } = useSelector(
    (state) => state.allProjectData
  );
  let dispatch = useDispatch();
  const [date, setDate] = useState(new Date());
  const [logs, setLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [activeTab, setActiveTab] = useState("all");
  const [totalItems, setTotalItems] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [actionFilter, setActionFilter] = useState("all");
  const [selectedProjectId, setSelectedProjectId] = useState("all");
  const [selectedUserId, setSelectedUserId] = useState("all");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [employees, setEmployees] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const getAllLogsByOrg = async (page, limit,returnResultOnly = false) => {
    if (!returnResultOnly) setIsLoading(true);

    try {
      const filters = {
        project: selectedProjectId,
        user: selectedUserId,
        startDate,
        endDate,
      };

      if (page && limit) {
        filters.page = page;
        filters.limit = limit;
      }

      if (activeTab === "projects") {
        filters.onlyProjectLogs = true;
      }

      if (activeTab === "user") {
        filters.onlyUserLogs = true;
      }

      const data = await getLogsByOrg(
        userInfo?.organisation_id,
        userInfo?.token,
        filters
      );
      if (returnResultOnly) {
        return data.logs || [];
      } else {
        setLogs(data.logs);
        setTotalItems(data.pagination.total)
        setIsLoading(false);
      }
    } catch (error) {
      if (!returnResultOnly) setIsLoading(false);
      console.log(error);
      if (returnResultOnly) return [];
    }
  };

  const getEmployees = async () => {
    try {
      const data = await getOrgEmployees(
        userInfo?.organisation_id,
        userInfo?.token
      );
      setEmployees(data);
    } catch (error) {
      console.log(error);
    }
  };

  const filteredLogs = logs.filter((log) => {
    const matchesSearch =
      log.user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      log.action_type.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesAction =
      actionFilter === "all" || log.action_type === actionFilter;

    return matchesSearch && matchesAction;
  });

  const pageSize = 10;

  useEffect(() => {
    getAllLogsByOrg(currentPage, pageSize);
  }, [selectedProjectId, selectedUserId, startDate, endDate, activeTab,currentPage, pageSize]);

  useEffect(() => {
    getEmployees();
    dispatch(getAllProject());
  }, []);
const handleRefresh = () => {
    setIsLoading(true);
    setStartDate(null);
    setEndDate(null);
    setTimeout(() => setIsLoading(false), 1500);
    getAllLogsByOrg(currentPage, pageSize);
  };
  const logs1 = [
    {
      id: "log1",
      user: "Sarah Johnson",
      action: "User Login",
      resource: "System",
      timestamp: "2023-04-07 09:15:22",
      status: "Success",
      ip: "192.168.1.1",
    },
    {
      id: "log2",
      user: "Michael Chen",
      action: "Create Project",
      resource: "Projects",
      timestamp: "2023-04-07 10:30:45",
      status: "Success",
      ip: "192.168.1.2",
    },
    {
      id: "log3",
      user: "Admin",
      action: "License Update",
      resource: "Licensing",
      timestamp: "2023-04-06 14:22:10",
      status: "Success",
      ip: "192.168.1.3",
    },
    {
      id: "log4",
      user: "Emily Rodriguez",
      action: "Delete Page",
      resource: "Pages",
      timestamp: "2023-04-06 11:05:33",
      status: "Success",
      ip: "192.168.1.4",
    },
    {
      id: "log5",
      user: "David Kim",
      action: "User Login",
      resource: "System",
      timestamp: "2023-04-05 16:45:12",
      status: "Failed",
      ip: "192.168.1.5",
    },
    {
      id: "log6",
      user: "Admin",
      action: "Team Creation",
      resource: "Teams",
      timestamp: "2023-04-05 13:20:55",
      status: "Success",
      ip: "192.168.1.3",
    },
    {
      id: "log7",
      user: "Sarah Johnson",
      action: "Account Creation",
      resource: "Users",
      timestamp: "2023-04-04 09:30:18",
      status: "Success",
      ip: "192.168.1.1",
    },
    {
      id: "log8",
      user: "Michael Chen",
      action: "Page Restore",
      resource: "Pages",
      timestamp: "2023-04-04 11:15:42",
      status: "Success",
      ip: "192.168.1.2",
    },
  ];

  const exportFunction = async (type,all) => {
   let logsToExport;

  if (all === "all") {
    try {
      logsToExport = await getAllLogsByOrg(null, null, true);
    } catch (error) {
      console.error("Failed to fetch all logs:", error);
      return;
    }
  } else {
    logsToExport = filteredLogs;
  }
    handleExport(type, logsToExport);
    setIsOpen(false);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const actionTypes = Array.from(new Set(logs.map((item) => item.action_type)));

  const columns = [
    {
      header: "Timestamp",
      accessor: "createdAt",
      cell: (value) =>
        new Intl.DateTimeFormat("en-US", {
          dateStyle: "medium",
          timeStyle: "short",
        }).format(new Date(value)),
    },
    {
      header: "User",
      accessor: "user.name",
      cell: (value, row) => (
        <span className="py-4">{row.user?.name || "--"}</span>
      ),
    },
    {
      header: "Action",
      accessor: "action_type",
    },
    {
      header: "Projects/Pages",
      accessor: "project.project_name",
      cell: (value, row) => row.project?.project_name || row.page?.project_name,
    },
    {
      header: "Details",
      accessor: "details",
    },
    {
      header: "IP Address",
      accessor: "ip_address",
    },
  ];

  const handleDateChange = ({ startDate, endDate }) => {
    const start = startDate.toISOString();
    const end = endDate.toISOString();

    setStartDate(start);
    setEndDate(end);
  };

  return (
    <div className="space-y-6">
      <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
        <div className="border-b border-gray-200 px-6 py-4">
          <h3 className="text-lg font-semibold text-gray-900">Activity Logs</h3>
          <p className="text-sm text-gray-500">
            View and filter projects activity logs
          </p>
        </div>
        <div className="px-6 py-4">
          <div className="mb-6 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <div className="flex flex-1 gap-2">
              <div className="relative flex-1">
                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                  <Search className="h-4 w-4 text-gray-500" />
                </div>
                <input
                  type="text"
                  placeholder="Search logs..."
                  className="block w-full rounded-md border border-gray-300 bg-white py-2 pl-10 pr-3 shadow-sm focus:border-red-500 focus:outline-none focus:ring-red-500 sm:text-sm"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              {/* <button
                  type="button"
                  className="inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
                  onClick={() => setShowCalendar(!showCalendar)}
                >
                  <CalendarIcon className="mr-2 h-4 w-4" />
                  {date ? formatDate(date) : "Pick a date"}
                </button> */}
              <DateRangeFilter onDateChange={handleDateChange} />

              {/* {showCalendar && (
                  <div className="absolute right-0 z-10 mt-2 w-64 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="p-4">
                      <div className="mt-4 flex justify-end">
                        <button
                          type="button"
                          className="rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700"
                          onClick={() => setShowCalendar(false)}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </div>
                )} */}

              <button
                type="button"
                className="inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
                onClick={() => setShowFilters(!showFilters)}
              >
                <Filter className="mr-2 h-4 w-4" />
                Filters
                <ChevronDown
                  className={`ml-2 h-4 w-4 transition-transform ${
                    showFilters ? "rotate-180" : ""
                  }`}
                />
              </button>
            </div>

            <div className="flex gap-2">
              <button
                type="button"
                className="inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
                onClick={handleRefresh}
                disabled={isLoading}
              >
                <RefreshCw
                  className={`mr-2 h-4 w-4 ${isLoading ? "animate-spin" : ""}`}
                />
                Refresh
              </button>

              <div
                className="relative inline-block text-left"
                ref={dropdownRef}
              >
                <button
                  onClick={() => setIsOpen(!isOpen)}
                  type="button"
                  className="inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
                >
                  <Download className="mr-2 h-4 w-4" />
                  Export
                  <ChevronDown
                    className={`ml-2 h-4 w-4 transition-transform duration-200 ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {isOpen && (
                  <div className="absolute right-0 mt-2 w-56 origin-top-right rounded-md overflow-hidden bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-10">
                    <div className="py-1">
                      <button
                        onClick={() => exportFunction("pdf")}
                        className="flex w-full items-center px-4 py-2 text-xs text-gray-700 hover:bg-gray-100"
                      >
                        <FileText className="mr-2 h-4 w-4" />
                        <span>PDF Document</span>
                      </button>
                      <button
                        onClick={() => exportFunction("pdf", "all")}
                        className="flex w-full items-center px-4 py-2 text-xs text-gray-700 hover:bg-gray-100"
                      >
                        <FileText className="mr-2 h-4 w-4" />
                        <span>PDF Document (All Logs)</span>
                      </button>
                      <button
                        onClick={() => exportFunction("excel")}
                        className="flex w-full items-center px-4 py-2 text-xs text-gray-700 hover:bg-gray-100"
                      >
                        <FileSpreadsheet className="mr-2 h-4 w-4" />
                        <span>Excel Spreadsheet</span>
                      </button>
                      <button
                        onClick={() => exportFunction("excel", "all")}
                        className="flex w-full items-center px-4 py-2 text-xs text-gray-700 hover:bg-gray-100"
                      >
                        <FileSpreadsheet className="mr-2 h-4 w-4" />
                        <span>Excel Spreadsheet (All Logs)</span>
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {showFilters && (
            <div className="mb-6 grid gap-4 rounded-lg border p-4 md:grid-cols-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Action Type
                </label>
                <select
                  value={actionFilter}
                  onChange={(e) => setActionFilter(e.target.value)}
                  className="mt-1 block w-full rounded-md border border-gray-300 bg-white px-3 py-2 shadow-sm focus:border-red-500 focus:outline-none focus:ring-red-500 sm:text-sm"
                >
                  <option value="all">All Actions</option>
                  {actionTypes?.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Projects
                </label>
                <select
                  value={selectedProjectId}
                  onChange={(e) => setSelectedProjectId(e.target.value)}
                  className="mt-1 block w-full rounded-md border border-gray-300 bg-white px-3 py-2 shadow-sm focus:border-red-500 focus:outline-none focus:ring-red-500 sm:text-sm"
                >
                  <option value="all">All Projects</option>
                  {allProjectData?.map((item, index) => (
                    <option key={index} value={item._id} className="capitalize">
                      {item.project_name}
                    </option>
                  ))}
                </select>
              </div>

              {/* <div>
                <label className="block text-sm font-medium text-gray-700">
                  Status
                </label>
                <select className="mt-1 block w-full rounded-md border border-gray-300 bg-white px-3 py-2 shadow-sm focus:border-red-500 focus:outline-none focus:ring-red-500 sm:text-sm">
                  <option value="all">All Statuses</option>
                  <option value="success">Success</option>
                  <option value="failed">Failed</option>
                  <option value="pending">Pending</option>
                </select>
              </div> */}

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  User
                </label>
                <select
                  value={selectedUserId}
                  onChange={(e) => setSelectedUserId(e.target.value)}
                  className="mt-1 block w-full rounded-md border border-gray-300 bg-white px-3 py-2 shadow-sm focus:border-red-500 focus:outline-none focus:ring-red-500 sm:text-sm"
                >
                  <option value="all">All Users</option>
                  {employees?.map((item, index) => (
                    <option key={index} value={item._id} className="capitalize">
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

          <div className="mb-4 border-b border-gray-200">
            <nav className="-mb-px flex space-x-8" aria-label="Tabs">
              <button
                style={activeTab === "all" ? { borderBottom: "2px solid" } : {}}
                onClick={() => setActiveTab("all")}
                className={`whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium ${
                  activeTab === "all"
                    ? "border-red-500 text-red-600"
                    : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                }`}
              >
                All Logs
              </button>
              <button
                style={
                  activeTab === "projects" ? { borderBottom: "2px solid" } : {}
                }
                onClick={() => setActiveTab("projects")}
                className={`whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium ${
                  activeTab === "projects"
                    ? "border-red-500 text-red-600"
                    : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                }`}
              >
                Projects
              </button>
              <button
                style={
                  activeTab === "user" ? { borderBottom: "2px solid" } : {}
                }
                onClick={() => setActiveTab("user")}
                className={`whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium ${
                  activeTab === "user"
                    ? "border-red-500 text-red-600"
                    : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                }`}
              >
                User Activity
              </button>
            </nav>
          </div>

          {activeTab === "all" && (
            // <div className="overflow-hidden rounded-md border border-gray-200">
            //   <div className="overflow-x-auto">
            //     <table className="min-w-full divide-y divide-gray-200">
            //       <thead className="bg-gray-50">
            //         <tr>
            //           <th
            //             scope="col"
            //             className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
            //           >
            //             Timestamp
            //           </th>
            //           <th
            //             scope="col"
            //             className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
            //           >
            //             User
            //           </th>
            //           <th
            //             scope="col"
            //             className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
            //           >
            //             Action
            //           </th>
            //           <th
            //             scope="col"
            //             className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
            //           >
            //             Projects
            //           </th>
            //           <th
            //             scope="col"
            //             className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
            //           >
            //             Details
            //           </th>
            //           <th
            //             scope="col"
            //             className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
            //           >
            //             IP Address
            //           </th>
            //         </tr>
            //       </thead>
            //       <tbody className="divide-y divide-gray-200 bg-white">
            //         {logs
            //           .filter(
            //             (log) =>
            //               log.user.name
            //                 .toLowerCase()
            //                 .includes(searchTerm.toLowerCase()) ||
            //               log.action_type
            //                 .toLowerCase()
            //                 .includes(searchTerm.toLowerCase())
            //           )
            //           .map((log) => (
            //             <tr
            //               key={log.id}
            //               className="cursor-pointer hover:bg-gray-50"
            //             >
            //               <td className="whitespace-nowrap px-6 py-4 text-sm font-mono text-gray-500">
            //                 {new Intl.DateTimeFormat("en-US", {
            //                   dateStyle: "medium",
            //                   timeStyle: "short",
            //                 }).format(new Date(log.createdAt))}
            //               </td>
            //               <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-900">
            //                 {log.user.name}
            //               </td>
            //               <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
            //                 {log.action_type}
            //               </td>
            //               <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
            //                 {log?.project?.project_name
            //                   ? log?.project?.project_name
            //                   : "--"}
            //               </td>
            //               <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
            //                 <span
            //                   className={`inline-flex rounded-full px-2 text-xs font-semibold leading-5 text-black`}
            //                 >
            //                   {log.details}
            //                 </span>
            //               </td>
            //               <td className="whitespace-nowrap px-6 py-4 text-sm font-mono text-gray-500">
            //                 {log.ip_address}
            //               </td>
            //             </tr>
            //           ))}
            //       </tbody>
            //     </table>
            //   </div>
            // </div>
            <Table
              data={filteredLogs}
              columns={columns}
              isLoading={isLoading}
              pagination={{
                currentPage,
                pageSize,
                totalItems,
                onPageChange: handlePageChange,
              }}
            />
          )}

          {(activeTab === "projects" || activeTab === "user") && (
            <div className="">
              {activeTab === "projects" && (
                <Table
                  data={filteredLogs}
                  columns={columns}
                  isLoading={isLoading}
                  pagination={{
                    currentPage,
                    pageSize,
                    totalItems,
                    onPageChange: handlePageChange,
                  }}
                />
              )}
              {activeTab === "user" && (
                <Table
                  data={filteredLogs}
                  columns={columns}
                  isLoading={isLoading}
                  pagination={{
                    currentPage,
                    pageSize,
                    totalItems,
                    onPageChange: handlePageChange,
                  }}
                />
              )}
            </div>
          )}
        </div>
        {/* <div className="flex justify-between border-t border-gray-200 px-6 py-4">
          <div className="text-sm text-gray-500">
            Showing 8 of 1,245 log entries
          </div>
          <div className="flex items-center gap-1">
            <button
              type="button"
              className="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
              disabled
            >
              Previous
            </button>
            <button
              type="button"
              className="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
            >
              1
            </button>
            <button
              type="button"
              className="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
            >
              2
            </button>
            <button
              type="button"
              className="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
            >
              3
            </button>
            <button
              type="button"
              className="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
            >
              Next
            </button>
          </div>
        </div> */}
      </div>

      <div className="flex items-center gap-2 rounded-lg bg-amber-50 p-2 text-amber-800">
        <AlertCircle className="w-5 flex-shrink-0" />
        <div className="flex flex-col gap-0">
          <p className="font-medium">Log Retention Policy</p>
          <p className="text-sm">
            Activity logs are retained for 90 days. For longer retention
            periods, please export logs or contact your administrator.
          </p>
        </div>
      </div>
    </div>
  );
}
